module.exports = {"TXTWCL_No_matches_found":{"id":"TXTWCL_No_matches_found","defaultMessage":"Căutarea nu a returnat rezultate"}}